/*global google */
/*global jQuery */
/*global document */
/*global require */
'use strict';
angular.module('app.map', ['ngRoute', 'ngResource', 'angular-jwt', 'ngFileUpload',"bw.paging","uiGmapgoogle-maps"])
  .config(['$routeProvider', function ($routeProvider) {
    $routeProvider.when('/washmap', {
      template: require('./map.html'),
      controller: 'mapCtrl'
    });
  }])
  .controller('mapCtrl', function ($rootScope, $scope, $translate, $interval, $timeout, $resource, $route, $location, $cookies, $window, AuthService, envService,uiGmapGoogleMapApi) {
    $rootScope.mainmenu="washes";
    $rootScope.menu = 'washmap';
    var APIURL = envService.read('apiUrl');

    $scope.map = { control : {}, center: { latitude: 37.50980, longitude: 127.03756 }, zoom: 13 };
    $scope.markers = [];
    $scope.lastStatus = 'A';
    uiGmapGoogleMapApi.then(function(maps) {
      var waitForMap = function(attempt) {
        attempt = attempt || 0;
        var gmap = $scope.map.control && typeof $scope.map.control.getGMap === 'function'
          ? $scope.map.control.getGMap()
          : null;
        if (!gmap) {
          if (attempt > 50) {
            console.error('Google map control not ready');
            return;
          }
          return $timeout(function() { waitForMap(attempt + 1); }, 100);
        }
        $resource(APIURL + '/maps/areas').get(function(data){
          for(var idx in data.areas) {
            var area = data.areas[idx];
            var path = area.POLYLINE;
            path = path.replace('\n','\\n');

            var color = '#5694cc';

            var polyline = new google.maps.Polygon({
              path: google.maps.geometry.encoding.decodePath(path),
              geodesic: true,
              strokeColor: color,
              fillColor : color,
              strokeOpacity: 1.0,
              fillOpacity : 0.3,
              strokeWeight: 2
            });
            polyline.setMap(gmap);
          }
          $scope.getMapCenter();
          $scope.fetchEmployees();
          $scope.createTopRightMenu();
        }, function(err){
          console.error(err);
          if(err.data && err.data.msg) {
            alert(err.data.msg);
          }
          else {
            alert($translate.instant('알수 없는 에러 입니다.'));
          }
        });
      };
      waitForMap();
    });

    $scope.getMapCenter = function() {
      $resource(APIURL + '/admin/maps/center').get(function(data) {
        $scope.map.center = data.center;
      }, function(err) {
        if(err.data && err.data.msg) {
          alert(err.data.msg);
        }
        else {
          alert($translate.instant('알수 없는 에러 입니다.'));
        }
      });
    };

    $scope.createTopRightMenu = function() {
      var map = $scope.map.control.getGMap();
      var controlDiv = document.createElement('div');
      controlDiv.className = 'btn-group';
      controlDiv.style.marginRight = '10px';
      controlDiv.style.marginTop = '10px';

      var buttonAll = document.createElement('button');
      buttonAll.type='button';
      buttonAll.className = 'btn btn-blue btn-lg';
      buttonAll.innerHTML = $translate.instant('전체');
      buttonAll.onclick = function() {
        $scope.fetchEmployees('A');
      };
      controlDiv.appendChild(buttonAll);
      var buttonWait = document.createElement('button');
      buttonWait.type='button';
      buttonWait.className = 'btn btn-blue btn-lg';
      buttonWait.innerHTML = $translate.instant('세차 대기중');
      buttonWait.onclick = function() {
        $scope.fetchEmployees('W');
      };
      controlDiv.appendChild(buttonWait);
      var buttonMove = document.createElement('button');
      buttonMove.type='button';
      buttonMove.className = 'btn btn-blue btn-lg';
      buttonMove.innerHTML = $translate.instant('이동중');
      buttonMove.onclick = function() {
        $scope.fetchEmployees('M');
      };
      controlDiv.appendChild(buttonMove);
      var buttonWash = document.createElement('button');
      buttonWash.type='button';
      buttonWash.className = 'btn btn-blue btn-lg';
      buttonWash.innerHTML = $translate.instant('세차중');
      buttonWash.onclick = function() {
        $scope.fetchEmployees('I');
      };
      controlDiv.appendChild(buttonWash);
      map.controls[google.maps.ControlPosition.TOP_RIGHT].push(controlDiv);
    };
    $scope.fetchEmployees = function(status) {
      if( status === null || status === undefined) {
        status = 'A';
      }
      $scope.lastStatus = status;
      $resource(APIURL + '/admin/employees/map?status='+status).get(function(data){
        // Create Left Summary
        var map = $scope.map.control.getGMap();
        var controlDiv = document.createElement('div');
        var controlUI = document.createElement('div');
        controlUI.style.backgroundColor = '#fff';
        controlUI.style.border = '2px solid #fff';
        controlUI.style.cursor = 'pointer';
        controlUI.style.marginBottom = '22px';
        controlUI.style.marginTop = '10px';
        controlUI.style.textAlign = 'center';
        controlUI.title = 'Click to recenter the map';
        controlDiv.appendChild(controlUI);

        var controlText = document.createElement('div');
        controlText.style.color = 'rgb(25,25,25)';
        controlText.style.fontFamily = 'Roboto,Arial,sans-serif';
        controlText.style.fontSize = '11px';
        controlText.style.lineHeight = '38px';
        controlText.style.paddingLeft = '5px';
        controlText.style.paddingRight = '5px';
        controlText.innerHTML = $translate.instant('전체 테크니션') + ' : '+ data.total_count + ' ' + $translate.instant('명')+'<br>  ' +
          $translate.instant('세차 대기중') + ' : '+data.wait_count + ' ' + $translate.instant('명')+'<br>  ' +
          $translate.instant('이동중') + ' : '+data.move_count + ' ' + $translate.instant('명')+'<br>  ' +
          $translate.instant('세차중') + ' : '+data.wash_count + ' ' + $translate.instant('명')+'<br>  ' +
          $translate.instant('퇴근') + ' : '+data.home_count + ' ' + $translate.instant('명');
        controlUI.appendChild(controlText);
        controlDiv.index = 1;
        console.log(map.controls[google.maps.ControlPosition.TOP_LEFT]);
        if (map.controls[google.maps.ControlPosition.TOP_LEFT].length > 0) {
          map.controls[google.maps.ControlPosition.TOP_LEFT].pop();
        }
        map.controls[google.maps.ControlPosition.TOP_LEFT].push(controlDiv);

        for(var markderIdx in $scope.markers) {
          var marker = $scope.markers[markderIdx];
          marker.setMap(null);
        }
        $scope.markers = [];
        for(var idx in data.employees) {
          var employee = data.employees[idx];
          $scope.addMarker(employee);
        }
      }, function(err){
        console.error(err);
        if(err.data && err.data.msg) {
          alert(err.data.msg);
        }
        else {
          alert($translate.instant('알수 없는 에러 입니다.'));
        }
      });
    };

    $scope.addMarker = function(employee) {
      var statusString = $translate.instant('세차 대기중');
      var bodyContent = '';
      console.log(employee);
      if (employee.ORDER_NO !== null) {
        if (employee.STATUS =='06' || employee.STATUS=='05-1') {
          statusString = $translate.instant('세차중');
          bodyContent = '<div id="bodyContent">'+
            '<p>'+$translate.instant('예상 완료시간')+' : '+employee.ORDER_EXPECTED_ENDDATE+'</p>'+
            '</div>';
        }
        else {
          statusString =$translate.instant('이동중');
        }
      }

      var contentString = '<div id="content">'+
        '<div id="siteNotice">'+
        '</div>'+
        '<h4 id="firstHeading" class="firstHeading">['+statusString+'] '+employee.name+'</h4>'+ bodyContent +
        '</div>';

      var infowindow = new google.maps.InfoWindow({
        content: contentString,
        disableAutoPan : true
      });

      var lat = parseFloat(employee.COORDS_X);
      var lng = parseFloat(employee.COORDS_Y);
      if (!isFinite(lat) || !isFinite(lng)) {
        return;
      }

      var marker_icon = (employee.JOB_TYPE =='W')
        ? 'https://maps.google.com/mapfiles/ms/icons/red-dot.png'
        : 'https://maps.google.com/mapfiles/ms/icons/blue-dot.png';
      var marker = new google.maps.Marker({
        position: { lat: lat, lng: lng },
        map: $scope.map.control.getGMap(),
        title: employee.name,
        label: employee.name,
        icon: marker_icon
      });

      infowindow.open($scope.map.control.getGMap(), marker);
      $scope.markers.push(marker);
    };

    //  타이머 Task
    var stop;
    $scope.fight = function() {
      // Don't start a new fight if we are already fighting
      if ( angular.isDefined(stop) ) return;
      console.log('++++startFight');
      stop = $interval(function() {
        console.log('++++fight');
        $scope.fetchEmployees($scope.lastStatus);
      }, 30000);
    };

    $scope.stopFight = function() {
      console.log("+++stopFight");
      if (angular.isDefined(stop)) {
        $interval.cancel(stop);
        stop = undefined;
      }
    };

    $scope.$on('$destroy', function() {
      $scope.stopFight();
    });
    $scope.fight();
  });



// WEBPACK FOOTER //
// ./src/app/employee/map.js